import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const TRAVEL = {
  nickname: 'PRODUCTS.TRAVEL.shortname',
  properties: [
    {
      name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.pattern(/^\d+$/)
      ]]
    },
    {
      name: 'travelType', key: 'TRAVEL_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_TYPE.PERSONAL', value: 'PERSONAL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_TYPE.FAMILY', value: 'FAMILY' }
        ]
      }
    },
    {
      name: 'travelDuration', key: 'TRAVEL_DURATION', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_DURATION.70', value: '70' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_DURATION.90', value: '90' }
        ]
      }
    },
    { name: 'travelDurationType', key: 'TRAVEL_DURATION_TYPE', group: 'OBJECT_INFO' },
    { name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO' },
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO' },
  ],
  icon: 'travel'
};
